export enum AssetTypeEnum {
  BUILDING = 'building',
  TECHNICAL_INSTALLATION = 'technical_installation',
  UNDEFINED = 'undefined',
}
